// Dashboard KPI API client.
import { request } from './api';

export const dashboardApi = {
    kpis: (params) => request('/dashboard/kpis', { params }),
    chartDaily: (params) => request('/dashboard/chart/daily', { params }),
    chartStatus: (params) => request('/dashboard/chart/status', { params }),
};
